export default function home() {

  $('.home-studios .studios-image').owlCarousel({
    items: 1,
    autoplay: false,
    loop: true,
    smartSpeed: 2000,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    mouseDrag: false,
    touchDrag: false
  });
	
	$('.home-studios .room-list a').hover(function(){
    $('.home-studios .room-list li').removeClass('active');
    $(this).parent().addClass('active');
    $('.home-studios .studios-image').trigger('to.owl.carousel', [$(this).data('slide-no')]);
  });

  $('.home-studios .room-list a').click(function(e) {
    e.preventDefault();
  });

}